export class LocationModel {
    constructor(data = {}) {
        this._location_id = data.location_id || this.generateId();
        this._company_id = data.company_id || '';
        this._name = data.name || '';
        this._description = data.description || null;
        this._address = data.address || null;
        this._location_type = data.location_type || 'General';
        this._is_active = data.is_active !== undefined ? data.is_active : true;
        // Handle timestamp conversion properly
        if (data.created_at) {
            this._created_at = typeof data.created_at === 'number' ? data.created_at : Date.now();
        }
        else {
            this._created_at = Date.now();
        }
        if (data.updated_at) {
            this._updated_at = typeof data.updated_at === 'number' ? data.updated_at : Date.now();
        }
        else {
            this._updated_at = Date.now();
        }
    }
    // Getters
    get location_id() {
        return this._location_id;
    }
    set location_id(location_id) {
        this._location_id = location_id;
    }
    get company_id() {
        return this._company_id;
    }
    set company_id(company_id) {
        this._company_id = company_id;
    }
    get name() {
        return this._name;
    }
    set name(name) {
        this._name = name;
    }
    get description() {
        return this._description;
    }
    set description(description) {
        this._description = description;
    }
    get address() {
        return this._address;
    }
    set address(address) {
        this._address = address;
    }
    get location_type() {
        return this._location_type;
    }
    set location_type(location_type) {
        this._location_type = location_type;
    }
    get is_active() {
        return this._is_active;
    }
    set is_active(is_active) {
        this._is_active = is_active;
    }
    get created_at() {
        return this._created_at;
    }
    set created_at(created_at) {
        this._created_at = created_at;
    }
    get updated_at() {
        return this._updated_at;
    }
    set updated_at(updated_at) {
        this._updated_at = updated_at;
    }
    // Business logic methods
    isActive() {
        return this._is_active;
    }
    activate() {
        this._is_active = true;
        this._updated_at = Date.now();
    }
    deactivate() {
        this._is_active = false;
        this._updated_at = Date.now();
    }
    hasAddress() {
        return this._address !== null && this._address.trim() !== '';
    }
    hasDescription() {
        return this._description !== null && this._description.trim() !== '';
    }
    getFullLocationInfo() {
        let info = this._name;
        if (this._address) {
            info += ` - ${this._address}`;
        }
        if (this._location_type && this._location_type !== 'General') {
            info += ` (${this._location_type})`;
        }
        return info;
    }
    // Serialization methods
    toJSON() {
        return {
            location_id: this._location_id,
            company_id: this._company_id,
            name: this._name,
            description: this._description,
            address: this._address,
            location_type: this._location_type,
            is_active: this._is_active,
            created_at: this._created_at,
            updated_at: this._updated_at,
        };
    }
    toFirestore() {
        return {
            location_id: this._location_id,
            company_id: this._company_id,
            name: this._name,
            description: this._description,
            address: this._address,
            location_type: this._location_type,
            is_active: this._is_active,
            created_at: this._created_at,
            updated_at: this._updated_at,
        };
    }
    generateId() {
        return `location_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    }
}
//# sourceMappingURL=LocationModel.js.map